function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "SVGRepo_bgCarrier",
  strokeWidth: 0
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "SVGRepo_tracerCarrier",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "SVGRepo_iconCarrier"
}, /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, " .bentblocks_een{fill:#448EF7;} "), /*#__PURE__*/React.createElement("path", {
  className: "bentblocks_een",
  d: "M18,16c0,1.105-0.895,2-2,2c-1.105,0-2-0.895-2-2c0-1.105,0.895-2,2-2C17.105,14,18,14.895,18,16z M7.543,7.494C5.354,9.684,4,12.708,4,16.049c0,3.341,1.354,6.365,3.543,8.555l1.418-1.418C7.133,21.358,6,18.833,6,16.049 c0-2.784,1.133-5.309,2.961-7.137L7.543,7.494z M11.126,10.916C9.812,12.23,9,14.045,9,16.049s0.812,3.819,2.126,5.133l1.416-1.416 C11.59,18.814,11,17.499,11,16.049c0-1.45,0.59-2.765,1.542-3.717L11.126,10.916z M24.418,7.494L23,8.912 c1.828,1.828,2.961,4.353,2.961,7.137c0,2.784-1.133,5.309-2.961,7.137l1.418,1.418c2.189-2.189,3.543-5.214,3.543-8.555 C27.961,12.708,26.607,9.684,24.418,7.494z M20.874,10.916l-1.416,1.416C20.41,13.284,21,14.599,21,16.049 c0,1.45-0.59,2.765-1.542,3.717l1.416,1.416C22.187,19.868,23,18.053,23,16.049S22.187,12.23,20.874,10.916z"
}));

function SvgBroadcastSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Uploaded to svgrepo.com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcastSvgrepoCom);
export default __webpack_public_path__ + "static/media/broadcast-svgrepo-com.48f47331.svg";
export { ForwardRef as ReactComponent };